import $ from 'jquery'

$(document).on('submit', '#push-account form.login, #push-account form.register', function(e) {
    let $form   = $(this)
    let $submit = $form.find('button[type="submit"]')
    let data    = $form.serializeArray()

    data.push({
        name: $submit.attr('name'),
        value: null
    })

    $form.block()
    $form.find('.woocommerce-notices-wrapper').remove()

    $.post($form.attr('action'), data)
        .then(function(data) {
            let html        = document.createElement('html')
            html.innerHTML  = data
            let $data       = $(html)
            let $body       = $data.find('body')
            let $notice     = $data.find('.woocommerce-notices-wrapper')

            if ($body.hasClass('logged-in')) {
                $notice = $(`
                    <div class="woocommerce-notices-wrapper">
                        <div class="woocommerce-info" role="alert">
                            Please wait&hellip;
                        </div>
                    </div>
                `)
                
                $notice.prependTo($form)
                // Reload on successfull login
                window.location.reload()
            } else {
                // Otherwise show the error messages
                $notice.prependTo($form)
            }
        })
        .always(function() {
            $form.unblock()
        })

    e.preventDefault()
})